import { Sort } from '@/models';

/**
 * Sorts an array of items
 * @param items the list of things to sort
 * @param options an options object for the sorting configuration
 */
export default function sortItems<T>(items: T[], options: Sort) {
  const { sortBy, sortDesc, customSorter, locale = 'en' } = options;
  const isObject = items.length && typeof items[0] === 'object';

  if (!sortBy && isObject) {
    return items;
  }

  return [...items].sort((a, b) => {
    let sortA = a[sortBy] || a;
    let sortB = b[sortBy] || b;

    if (sortDesc) {
      [sortA, sortB] = [sortB, sortA];
    }

    if (customSorter) {
      return customSorter(sortA, sortB);
    }

    [sortA, sortB] = [sortA, sortB].map((s) => (s || '').toString().toLocaleLowerCase());

    if (sortA !== sortB) {
      const sortResult = sortA.localeCompare(sortB, locale);

      if (sortResult) {
        return sortResult;
      }
    }

    return 0;
  });
}
